export default "__VITE_ASSET__pjxfJ1ni__"